/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React, { useEffect, useState } from 'react';

import config from '../../config';
import { useDispatch, useSelector } from '../../interfaces/State';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import MarkdownRenderer from '../MarkdownRenderer';

import LearningRecapRating from './LearningRecapRating';
import ThanksForRating from './ThanksForRating';

const TopLeftBox1Style = {
  backgroundColor: tokens.colors.pink,
  width: 200,
  height: 18,
  left: 0,
  top: 0,
  position: 'absolute',
} as const;

const TopLeftBox2Style = {
  backgroundColor: tokens.colors.purple,
  width: 100,
  height: 18,
  left: 0,
  top: 18,
  position: 'absolute',
} as const;

type Props = Record<string, unknown>;

export const ShowLearningRecap: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const userId = useSelector(selectors.selectUserSettings).get('id');
  const courseId = useSelector(selectors.selectCourse).get('id');
  const [isLearningRecapRated, setIsLearningRecapRated] = useState(false);

  const learningRecap = useSelector(selectors.selectLearningRecap);
  if (learningRecap === null) {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'heap_event',
        heap_event_name: 'Learn - Campus - Learn Recap Modal Shown',
        heap_event_properties: {
          app_id: config.appName,
          event_category: 'learning',
          identity: userId,
          course_id: courseId,
        },
      });
    }
  }, [courseId, userId]);

  return (
    <>
      <div css={TopLeftBox1Style} />
      <div css={TopLeftBox2Style} />
      <Dialog.Header css={{ paddingTop: tokens.spacing.xxlarge }}>
        Your recent learnings
      </Dialog.Header>
      <Dialog.Body>
        <MarkdownRenderer
          markdown={learningRecap.learningRecap}
          theme="LIGHT"
        />
      </Dialog.Body>
      <Dialog.Footer>
        {!isLearningRecapRated && (
          <LearningRecapRating
            onRateClick={() => {
              setIsLearningRecapRated(true);
            }}
          />
        )}
        {isLearningRecapRated && <ThanksForRating />}
        <Dialog.Button
          data-cy="learn-recap-got-it-button"
          variant="primary"
          onClick={() => {
            dispatch(actions.removeModal());
          }}
        >
          Got it
        </Dialog.Button>
      </Dialog.Footer>
    </>
  );
};
